module.exports = __webpack_public_path__ + "static/img/fluent-slide-multiple-24-regular.2ea02e38.svg";